export default __webpack_public_path__ + "static/media/GroupRemoveBlack.e096398e.svg";